import React from 'react'

import { TextContent } from 'common/builder/components/chart/FlowChart/components/Block/components/TextContent/TextContent'
import { BlockComponent } from 'common/builder/components/chart/FlowChart/components/Block/types'
import { Button } from 'common/builder/components/chart/FlowChart/components/Button/Button'
import { ContentContainer } from 'common/builder/components/chart/FlowChart/components/ContentContainer/ContentContainer'
import { InteractiveBlockContainer } from 'common/builder/components/chart/FlowChart/components/InteractiveBlockContainer/InteractiveBlockContainer'
import { useFilteredFromSmartlinksButtons } from 'common/builder/components/chart/FlowChart/hooks/useFilteredFromSmartlinksButtons'
import { useTextContentParts } from 'common/builder/components/chart/FlowChart/hooks/useTextContentParts'
import { FlowChartTextBlock } from 'common/builder/components/chart/FlowChart/types/FlowChartTextBlock'

export const TextGenericBlock: BlockComponent<FlowChartTextBlock> = ({ block }) => {
  const { text, buttons } = block.data
  const { textContent, smartLinkButtonIdsMap } = useTextContentParts(text)
  const isTextEmpty = !text
  const isEmptyContainer = isTextEmpty && buttons.length === 0
  const filteredButtons = useFilteredFromSmartlinksButtons(buttons, smartLinkButtonIdsMap)

  return (
    <InteractiveBlockContainer id={block.id}>
      <ContentContainer isEmpty={isEmptyContainer}>
        <TextContent content={isTextEmpty ? null : textContent} buttons={buttons} />
        {filteredButtons.map((button) => (
          <Button key={button.id} button={button} />
        ))}
      </ContentContainer>
    </InteractiveBlockContainer>
  )
}
